import React from 'react';
import {TypicalMessage, TypicalMessageProps} from './TypicalMessage';

export function OrderStatusChanged(props: TypicalMessageProps) {
    return <TypicalMessage
            model={props.model}
            options={props.options}
            replace={{was: '—'}}
            messageKeysWithStatusId={['was', 'became']}
    />;
}
